"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function IOLibraryOutline(props) {
    let { width, height, size } = props;
    if (size !== undefined) {
        width = size;
        height = size;
    }
    if (width === undefined && height === undefined) {
        width = 16;
        height = 16;
    }
    return (react_1.default.createElement("svg", { className: "glx--icon glx-io-icon", width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
        react_1.default.createElement("rect", { width: "64", height: "368", x: "32", y: "96", fill: "none", stroke: "#000", strokeLinejoin: "round", strokeWidth: "32", rx: "16", ry: "16" }),
        react_1.default.createElement("path", { fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M112 224L240 224" }),
        react_1.default.createElement("path", { fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M112 400L240 400" }),
        react_1.default.createElement("rect", { width: "128", height: "304", x: "112", y: "160", fill: "none", stroke: "#000", strokeLinejoin: "round", strokeWidth: "32", rx: "16", ry: "16" }),
        react_1.default.createElement("rect", { width: "96", height: "416", x: "256", y: "48", fill: "none", stroke: "#000", strokeLinejoin: "round", strokeWidth: "32", rx: "16", ry: "16" }),
        react_1.default.createElement("path", { fill: "none", stroke: "#000", strokeLinejoin: "round", strokeWidth: "32", d: "M422.46 96.11l-40.4 4.25c-11.12 1.17-19.18 11.57-17.93 23.1l34.92 321.59c1.26 11.53 11.37 20 22.49 18.84l40.4-4.25c11.12-1.17 19.18-11.57 17.93-23.1L445 115c-1.31-11.58-11.42-20.06-22.54-18.89z" })));
}
exports.default = IOLibraryOutline;
